export default __webpack_public_path__ + "static/media/ic_person.8f6796f4.svg";